import { ConsentPolicy } from '@wix/wix-bootstrap-api';
import { GeoData } from '@wix/wix-common-aspects';
import { AppConfig } from '../../config';
import { Identity } from '../../utils/fetchIdentity';

export interface ConfigStoreState {
  currentLanguage: string;
  supportedLanguages: string[];
  baseURL: string;
  domain: string;
  // Request-derived device flag (Smartphone/Tablet => true). Set server-side from
  // web.UserAgentInfo and serialized to the client so SSR and hydration agree on the
  // device branch. Do NOT derive this from useMediaQuery — that is unsafe during SSR.
  isMobile: boolean;
  geoData: GeoData | undefined;
  renamedCategories: AppConfig['renamedCategory'];
  templatePageSessionId: string;
  imagesMediaPlatformDomain: string;
  consentPolicy?: ConsentPolicy;
  introReferrer: string;
  introQueryParams: Record<string, string>;
  identity: Identity;
}

export class ConfigStore {
  constructor(public readonly config: ConfigStoreState) {}

  serialize(): ConfigStoreState {
    return this.config;
  }
}
